<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 36 36"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M32.914 28.262C33.585 28.612 34 29.278 34 30c0 .723-.416 1.39-1.086 1.736l-5.796 3.015c-.31.164-.663.25-1.015.25-1.16 0-2.103-.89-2.103-1.985v-6.031c0-1.095.943-1.984 2.105-1.984.35 0 .701.085 1.013.247l5.796 3.015zM18.872 30.57a1.99 1.99 0 0 1 2.198 1.97 2.005 2.005 0 0 1-1.802 1.988 16.11 16.11 0 0 1-6.58-.699C7.494 32.17 3.5 27.81 2.364 22.552c-1.11-5.136.395-9.944 3.426-13.426a5.028 5.028 0 0 1 .483-6.631c2.023-1.993 5.305-1.993 7.328 0 .458.449.795.966 1.04 1.514a16.255 16.255 0 0 1 5.71-.092c.252.041.488.123.736.173a4.93 4.93 0 0 1 1.074-1.595c2.022-1.993 5.305-1.993 7.328 0 1.886 1.857 1.99 4.776.36 6.78a15.066 15.066 0 0 1 3.166 6.417c.521 2.342.49 4.615.022 6.728a2.046 2.046 0 0 1-2.972 1.348 1.97 1.97 0 0 1-.988-2.173 11.103 11.103 0 0 0-.187-5.607c-1.234-4.225-4.91-7.481-9.324-8.155C11.58 6.611 4.807 13.385 6.24 21.273c.802 4.416 4.309 8.024 8.745 9.043a11.96 11.96 0 0 0 3.888.254zM16.81 13.963c0-1.062.875-1.923 1.954-1.923 1.077 0 1.954.861 1.954 1.923v8.081c0 .63-.52 1.14-1.158 1.14h-5.208c-1.082 0-1.954-.862-1.954-1.923 0-1.064.872-1.924 1.954-1.924h2.458v-5.374z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
